import { render, staticRenderFns } from "./spiderChartTeam.vue?vue&type=template&id=72aac37c&scoped=true&"
import script from "./spiderChartTeam.vue?vue&type=script&lang=js&"
export * from "./spiderChartTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72aac37c",
  null
  
)

export default component.exports